<div>
    <!-- 标题 -->
    <p *ngIf="isEdit">{{i18n.selectedObj}}</p>

    <!-- 选择标签 -->
    <div class="selected" *ngIf="isEdit">
        <ng-container
            *ngFor="let item of selectData">
            <div class="selected-item">
                <div class="item-tab">
                    <span class="item-tab-name">{{item.key}}</span>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- 表格 -->
    <div class="table-container">
        <n-data-table #dt
            id="windows-local-access-group-permit-table"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs"
            [data]="initData"
            (selectionChange)="onSelectDataChange($event)"
            [(selection)]="selectData">
        </n-data-table>
    </div>
</div>
